// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"26123d35","543":"a158b461","565":"fa2449ea"}[chunkId] + ".chunk.css";
};